import { TrackingMiddleware } from '../types';

const eventDebugger: TrackingMiddleware = () => async event => {
  if ((process.env as { NODE_ENV: string }).NODE_ENV === 'test') {
    return;
  }

  console.info(`🧭 Would have tracked event "${event.name}"`, {
    name: event.name,
    _data: event.data,
    _context: event.context,
  });

  event.apply({
    __debugMode: true,
  });
};

export default eventDebugger;
